import PlacedOrders from '@/pages/PlacedOrders'
export default {
    path: '',
    component: PlacedOrders,
    children: [
        {
            path: '/placed/orders',
            name: 'Placed Orders',
            component: PlacedOrders,
        },
        {
            path: '/placed/orders/:ref',
            name: 'Placed Order',
            component: PlacedOrders,
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/placedorders.js